require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-object-oriented-programming-inherit-behaviors-from-a-supertype.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-object-oriented-programming-inherit-behaviors-from-a-supertype");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-object-oriented-programming-inherit-behaviors-from-a-supertype!./.cache/json/javascript-algorithms-and-data-structures-object-oriented-programming-inherit-behaviors-from-a-supertype.json
// module id = 2447
// module chunks = 231608221292675